import React, { useState } from "react";
import Page from "components/Page";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "./TaskManagement.scss";
import styles from "./TaskManagement.module.scss";
import MyTasks from "./MyTasks";
import AdminTask from "./Admin";
import constants, { taskTabStatus } from "../../../constants";
import useCardModule from "./hooks/useCardModule";
import { useAllTasks } from "repositories/task-management-repository";
import useTaskModule from "./hooks/useTaskModule";
import { encodeId, getStorage, setStorage } from "utils";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import useModuleDisplayOwner, {
  getModuleDisplayOwnerName,
} from "hooks/useModuleDisplayOwner";

const TaskManagement = ({ t, history }) => {
  const cacheActiveArchived = getStorage(constants.tasks.cache.archivedListing);
  const [isArchive, setIsArchive] = useState(
    cacheActiveArchived?.isArchived || false
  );
  const isChatFromDashBoard = getStorage("isChatFromDashBoard");
  const isFromOwnerOfficeModule = getStorage("isFromOwnerOfficeModule");
  const {
    data: { activeTab },
    methods: { manageTab },
  } = useCardModule();

  const {
    tasks,
    searchValue,
    handleSearchTerm,
    selectedOwner,
    officeFilter,
    staffFilter,
    statusFilter,
    priorityFilter,
    isLoading,
    totalItems,
    isFilterApply,
    accountOwnerId,
    sortBy,
    priority,
    status,
    setStatus,
    setPriority,
    setPageNumber,
    setStatusFilter,
    setPriorityFilter,
    handleApplyFilters,
    setOfficeFilter,
    setStaffFilter,
    resetFilter,
    handleAction,
    deleteAction,
    setSortBy,
    handleArchiveApi,
    isOwner,
    isStaff,
  } = useTaskModule(useAllTasks, isArchive);

  const goToPreviousScreen = () => {
    let routing = "";
    if (isFromOwnerOfficeModule?.officeSlection) {
      routing = constants.routes.accountOwner.officeOptions;
      history.push({
        pathname: routing.replace(
          ":officeId",
          encodeId(isFromOwnerOfficeModule.officeId)
        ),
      });
      return;
    } else if (isFromOwnerOfficeModule?.isAdminControl) {
      routing = constants.routes.staff.officeAdmin;
      history.push({
        pathname: routing.replace(
          ":officeId",
          encodeId(isFromOwnerOfficeModule.officeId)
        ),
      });
      return;
    } else if (isFromOwnerOfficeModule?.staffOfficeSlection) {
      routing = constants.routes.staff.officeOptions;
      history.push({
        pathname: routing.replace(
          ":officeId",
          encodeId(isFromOwnerOfficeModule.officeId)
        ),
      });
      return;
    } else {
      if (isChatFromDashBoard) {
        history.push(constants.routes.dashboard.managerDashboard);
      } else {
        history.push("/Offices");
      }
    }
  };
  const { dataAccessValues, effectiveOwnerId, effectiveOwnerIdString } = useAccountOwnerCommon();
  const displayOwner = useModuleDisplayOwner();

  return (
    <Page
      onBack={goToPreviousScreen}
      className={
        styles["task_management_main_parent_wrapper"] + " scheduler-page"
      }
    >
      <div className={styles["btn_heading_wrapper"]}>
        <div>
          <h2 className="page-title mb-0">
            {!isArchive
              ? t("taskManagement.ongoingTasks")
              : t("taskManagement.archiveTask")}
          </h2>
          {isStaff && displayOwner?.id && activeTab === 2 ? (
            <div className={"show-owner-name-text marginTop10"}>
                {t("taskManagement.showTaskfor")}
                <span>
                  {` '${getModuleDisplayOwnerName(displayOwner)}' `}
                </span>
                {t("dashBoard.office")}
            </div>
          ) : (
            null
          )}
        </div>
        <div className={styles["btn_wrapper"]}>
          <button
            className="button button-round button-border button-dark w-sm-100"
            title="cancel"
            onClick={() => {
              setIsArchive(!isArchive);
              setStorage(constants.tasks.cache.archivedListing, {
                isArchived: !isArchive,
              });
            }}
          >
            {!isArchive
              ? t("taskManagement.archivedNotes")
              : t("taskManagement.onGoingTasks")}
          </button>
          {(isOwner ||
            (isStaff && dataAccessValues?.isAdmin && activeTab === taskTabStatus.assignedByMe)) && (
            <>
              <Link
                to={{
                  pathname:constants.routes.taskManagements.taskPerformance,
                  search: effectiveOwnerIdString?`?${effectiveOwnerIdString}`:""
                }}
                className="button button-round button-border button-dark w-sm-100"
                title="cancel"
              >
                {t("taskManagement.taskPerformance")}
              </Link>

              <Link
                to={{
                  pathname:constants.routes.taskManagements.taskManagementAddNote,
                  search: effectiveOwnerIdString?`?${effectiveOwnerIdString}`:""
                }}
                className="button button-round button-shadow w-sm-100"
                title="save"
              >
                {t("taskManagement.addNewTask")}
              </Link>
            </>
          )}
        </div>
      </div>
      <div className={styles["wrapper_card"]}>
        {isOwner ? (
          <MyTasks
            tasks={tasks}
            searchValue={searchValue}
            handleSearchTerm={handleSearchTerm}
            officeFilter={officeFilter}
            setOfficeFilter={setOfficeFilter}
            handleApplyFilters={handleApplyFilters}
            staffFilter={staffFilter}
            setStaffFilter={setStaffFilter}
            resetFilter={resetFilter}
            statusFilter={statusFilter}
            priorityFilter={priorityFilter}
            setStatusFilter={setStatusFilter}
            setPriorityFilter={setPriorityFilter}
            isLoading={isLoading}
            totalItems={totalItems}
            setPageNumber={setPageNumber}
            handleAction={handleAction}
            deleteAction={deleteAction}
            isArchive={isArchive}
            isFilterApply={isFilterApply}
            accountOwnerId={accountOwnerId}
            sortBy={sortBy}
            setSortBy={setSortBy}
            priority={priority}
            setPriority={setPriority}
            status={status}
            setStatus={setStatus}
            handleArchiveApi={handleArchiveApi}
          />
        ) : (
          <AdminTask
            activeTab={activeTab}
            manageTab={manageTab}
            tasks={tasks}
            searchValue={searchValue}
            handleSearchTerm={handleSearchTerm}
            officeFilter={officeFilter}
            setOfficeFilter={setOfficeFilter}
            handleApplyFilters={handleApplyFilters}
            staffFilter={staffFilter}
            setStaffFilter={setStaffFilter}
            resetFilter={resetFilter}
            statusFilter={statusFilter}
            priorityFilter={priorityFilter}
            setStatusFilter={setStatusFilter}
            setPriorityFilter={setPriorityFilter}
            isLoading={isLoading}
            totalItems={totalItems}
            setPageNumber={setPageNumber}
            handleAction={handleAction}
            deleteAction={deleteAction}
            isArchive={isArchive}
            isFilterApply={isFilterApply}
            accountOwnerId={accountOwnerId}
            sortBy={sortBy}
            setSortBy={setSortBy}
            priority={priority}
            setPriority={setPriority}
            status={status}
            setStatus={setStatus}
            handleArchiveApi={handleArchiveApi}
          />
        )}
      </div>
    </Page>
  );
};
export default withTranslation()(TaskManagement);
